import { t } from 'i18next'
import { getSocialIcon } from '../../../common/utils/feed'
import { ContentType } from '../../../types/Content'
import { ContentData } from '../../../types/Content'
import ContextBlock from '../../Exercise/ContextBlock'
import Icon from '../../Icon/Icon'
import styles from './ContentBase.module.css'

interface ContentBaseProps {
  data: ContentData
  title: string
  children: React.ReactNode
  context?: string
  type: ContentType
}

const ContentBase = ({
  data,
  context,
  title,
  children,
  type,
}: ContentBaseProps) => {
  const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1)
  const handleText = `@${data.meta.handle} ${t(
    'contentBase.via',
  )} ${capitalizedType}`

  return (
    <div className={styles.contentContainer}>
      <div className={styles.header}>
        {title && (
          <>
            <div className={styles.titleTextContainer}>
              <span className={styles.title}>{title}</span>
            </div>
            <a
              className={styles.titleTextContainer}
              href={data.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={`${styles.title} ${styles.url}`}>
                <Icon
                  uid={getSocialIcon(type)}
                  size={18}
                  style={{ marginRight: '0.2rem' }}
                />
                {handleText}
              </div>
            </a>
          </>
        )}
      </div>
      <div className={styles.childrenContainer}>{children}</div>
      {context && <ContextBlock text={context} />}
    </div>
  )
}

export default ContentBase
